export const itemRowStyles = {
  alignItems: 'center',
  justifyContent: 'space-between',
};

export const itemLabelStyles = {
  alignItems: 'center',
  gap: '4px',
  color: 'text.dark',
};

export const dividerStyles = {
  my: '12px',
};
